import "antd/lib/message/style";
import _message from "antd/lib/message";
var pushNotificationMessage = function pushNotificationMessage(type, text) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 4;
  var config = {
    content: text,
    duration: duration
  };
  if (key) {
    config.key = key;
  }
  switch (type) {
    case 'success':
      _message.success(config);
      break;
    case 'error':
      _message.error(config);
      break;
    case 'info':
      _message.info(config);
      break;
    case 'warning':
    case 'warn':
      _message.warning(config);
      break;
    case 'loading':
      _message.loading(config);
      break;
    default:
      _message.info(config);
      break;
  }
};
export default pushNotificationMessage;